import React from 'react';
import { View } from 'react-native';
import ZapSvg from '@assets/images/svg/zap.svg';

export interface ZapIconProps {
    size?: number;
    color?: string;
}

export function ZapIcon({ size = 32, color = '#FFFFFF' }: ZapIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <ZapSvg width={size} height={size} color={color} />
        </View>
    );
}

export default ZapIcon;

